<template>
  <div class="relative-position">
    <QCard v-if="fileList.length" class="row q-pa-md file-card">
      <QIcon
        class="q-pt-xs"
        name="eva-checkmark-circle-2"
        :color="color"
        size="20px"
      />
      <div class="col q-px-md">
        <p v-if="displayLabel" class="label text-body1">{{ displayLabel }}</p>
        <div :class="['row q-gutter-sm', { 'q-mt-xs': displayLabel }]">
          <QChip
            class="chip q-mr-none q-mb-none"
            v-for="(file, index) in fileList"
            :key="index"
            :disable="disable"
            removable
            outline
            @remove="() => remove(index)"
            :color="color"
          >
            <SAILink
              v-if="file.href"
              class="q-mr-xs text-ellipsis"
              :color="color"
              target="_blank"
              :label="file.name"
              :href="file.href"
              :disable="!file.href || disable"
            />
            <span v-else :class="`text-${color}`">
              {{ file.name }}
            </span>
          </QChip>
        </div>
      </div>
      <div class="row q-gutter-x-sm items-start">
        <QBtn
          flat
          round
          size="sm"
          :disable="disable"
          icon="eva-edit-outline"
          @click="edit"
        />
      </div>
    </QCard>
    <SAIFile
      :class="{ hidden: fileList.length }"
      v-bind="$attrs"
      :multiple="multiple"
      v-on="$listeners"
      :value="fileList"
      :disable="disable"
      :error="error"
      :clearable="clearable"
      ref="input"
    />
    <QLinearProgress
      indeterminate
      class="absolute-top loading-bar"
      v-if="loading"
    />
  </div>
</template>

<script>
import { QIcon, QBtn, QCard, QChip, QLinearProgress } from 'quasar';
export default {
  name: 'SAIFileDisplay',
  props: {
    value: undefined,
    loading: Boolean,
    displayLabel: {
      type: String
    },
    disable: Boolean,
    multiple: Boolean,
    error: Boolean,
    clearable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    color() {
      if (this.disable) {
        return 'grey-5';
      }
      return this.error ? 'negative' : 'primary';
    },
    fileList() {
      if (!this.value) {
        return [];
      }
      return Array.isArray(this.value) ? this.value : [this.value];
    }
  },
  methods: {
    edit(e) {
      this.$refs.input.pickFiles(e);
    },
    remove(index) {
      if (!this.multiple) {
        return this.$emit('input', undefined);
      }
      let arr = [...this.value];
      arr.splice(index, 1);
      this.$emit('input', arr);
    }
  },
  components: {
    QLinearProgress,
    QIcon,
    QBtn,
    QCard,
    QChip,
    SAIFile: () => import('../sai-file'),
    SAILink: () => import('../sai-link')
  }
};
</script>

<style lang="sass">
.loading-bar
  border-top-right-radius: $generic-border-radius
  border-top-left-radius: $generic-border-radius

.label
  padding-top: 6px

.file-card
  box-shadow: 0 2pt 6pt 0 rgba(0, 0, 0, 0.05)
  border: 1px solid $grey-3

.hidden
    visibility: hidden
    width: 0
    height: 0

.chip
  height: initial
</style>
